// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import api from '../../../services/api';

const validateBankAccountService = async (data) => {
  return api('https://api.craftyclicks.co.uk/bank/1.1/validate', data, 'POST');
};

const getFundraisePageDataService = async () => {
  return api(
    '/api/v2/pages/?type=fundraise_page.FundraisePage&fields=title,text,confirm_text', {}, 'GET'
  );
};

const RegisterCharityService = async (data) => {
  return api('/Sellitback.svc/RegisterCharity', data, 'POST');
};

const validatePhoneNumberService = async (data) => {
  return api('https://api.craftyclicks.co.uk/phone/1.1/validate', data, 'POST');
};

export {
  validatePhoneNumberService,
  validateBankAccountService,
  getFundraisePageDataService,
  RegisterCharityService,
};
